export default function Overlay({ show }) {
  if (!show) return null;

  return <div className='fixed top-0 left-0 bg-gray-bg-dim w-[100%] h-[100%] z-[999]' />;
}
